import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { ButtonGroup, ToggleButton } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

import { SOURCE_PRICING } from 'constants.js'
import PricingGrid from '../PricingGrid/PricingGrid'
import CurrencyDropdown from 'components/CurrencyDropdown/CurrencyDropDown'
import PlanPaymentModal from 'components/PlanPaymentModal/PlanPaymentModal'
import { setShowPaymentModal } from 'actions'
import { toggleSignUpModal } from 'Manage/actions'
import { getAllPlanPricesForCurrency } from 'constants/plans'
import { getAreaCurrency, TIMEZONE, availableCurrencies, isIndia } from 'constants/currency'

import './ProPlans.css'

export const ProPlans = ({
  className,
  email,
  hideFreeCard,
  hideMaxCard,
  hideTable,
  onPaymentClickCallback,
  onPaymentHideCallback,
  source,
  dispatch,
  showPaymentModal,
  upgradePlanId
}) => {
  const history = useHistory()
  const [pricingMode, setPricingMode] = useState('yearly')
  const [currentCurrency, setCurrentCurrency] = useState(getAreaCurrency(TIMEZONE))
  const [prices, setPrices] = useState(() => getAllPlanPricesForCurrency('yearly', getAreaCurrency(TIMEZONE)))
  const token = localStorage.getItem('token')

  // Force annual pricing for Indian users
  useEffect(() => {
    if (isIndia) {
      setPricingMode('yearly')
    }
  }, [])

  useEffect(() => {
    setPrices(getAllPlanPricesForCurrency(pricingMode, currentCurrency))
  }, [pricingMode, currentCurrency])

  const onSubPlanClick = (plan) => {
    const token = localStorage.getItem('token')
    if (!token) {
      dispatch(toggleSignUpModal(true))
      localStorage.setItem('planId', plan)
      return
    }
    dispatch(setShowPaymentModal({ showPaymentModal: true, upgradePlanId: plan, periodProp: pricingMode }))
    if (onPaymentClickCallback) {
      onPaymentClickCallback()
    }
  }

  const onPaymentModalHide = () => {
    dispatch(setShowPaymentModal({ showPaymentModal: false, upgradePlanId: null }))
    localStorage.removeItem('discount-code')
    if (onPaymentHideCallback) onPaymentHideCallback()
  }

  const onCurrencySelected = (currency) => {
    setCurrentCurrency(currency)
  }

  return (
    <>
      {/* used for not logged in user */}
      {(!token || source === SOURCE_PRICING) && (
        <PlanPaymentModal
          show={showPaymentModal}
          onHide={onPaymentModalHide}
          planId={upgradePlanId}
          history={history}
          periodProp={pricingMode}
          source={source}
          email={email}
        />
      )}
      <div id="pricing" className={`mt-3 mb-3 position-relative ${className}`}>
        {!isIndia && (
          <ButtonGroup>
            <ToggleButton
              id="monthly"
              className="cursor-pointer"
              size="sm"
              value="monthly"
              variant="outline-dark"
              type="radio"
              name="radio"
              checked={pricingMode === 'monthly'}
              onChange={(e) => setPricingMode(e.currentTarget.value)}
            >
              Monthly
            </ToggleButton>
            <ToggleButton
              id="yearly"
              className="cursor-pointer yearly-toggle"
              type="radio"
              name="radio"
              size="sm"
              variant="outline-dark"
              value="yearly"
              checked={pricingMode === 'yearly'}
              onChange={(e) => setPricingMode(e.currentTarget.value)}
            >
              Yearly
              <span className={`${pricingMode === 'yearly' ? 'percent-off-50' : 'percent-off-50-inactive'} ms-1`}>
                2 MONTHS FREE
              </span>
            </ToggleButton>
          </ButtonGroup>
        )}

        <div className="mt-4 mb-3 text-sm">
          Questions?{' '}
          <span className="link color-purple" onClick={() => window.$crisp.push(['do', 'chat:open'])}>
            <u>Chat with us</u>
          </span>
        </div>
        {localStorage.getItem('discount-code') && (
          <div style={{ marginBottom: '48px' }}>
            <span className="discount">Discount applied during checkout!</span>
          </div>
        )}
        <CurrencyDropdown
          selectedCurrency={prices.freePlan.symbol}
          onCurrencySelected={onCurrencySelected}
          availableCurrencies={availableCurrencies}
        />
        <div id="pricing" className="container-cards">
          <PricingGrid
            className="mt-3"
            period={pricingMode}
            prices={prices}
            onSubPlanClick={onSubPlanClick}
            hideFreeCard={hideFreeCard}
            hideMaxCard={hideMaxCard}
            hideTable={hideTable}
          />
        </div>
      </div>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({ dispatch })
const mapStateToProps = ({ upgrade, manage }) => ({
  showPaymentModal: upgrade.showPaymentModal,
  upgradePlanId: upgrade.upgradePlanId,
  userProfile: manage.userProfile
})

export default connect(mapStateToProps, mapDispatchToProps)(ProPlans)
